import { render, staticRenderFns } from "./AccountConfirm.vue?vue&type=template&id=388a65fc&scoped=true"
import script from "./AccountConfirm.vue?vue&type=script&lang=js"
export * from "./AccountConfirm.vue?vue&type=script&lang=js"
import style0 from "./AccountConfirm.vue?vue&type=style&index=0&id=388a65fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a65fc",
  null
  
)

export default component.exports